// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"48ffb14d","821":"b10d987a"}[chunkId] + ".chunk.js";
};